import { Component, OnInit } from '@angular/core';
import {NgForm} from '@angular/forms';
import {Observable} from 'rxjs';
import * as firebase from "firebase/app";

// Add the Firebase services that you want to use
import "firebase/auth";
import "firebase/database";


@Component({
  selector: 'app-addfaculties',
  templateUrl: './addfaculties.component.html',
  styleUrls: ['./addfaculties.component.css']
})
export class AddfacultiesComponent implements OnInit {

pictureurl:any;
description:any;
name:any;
  constructor() { }

  ngOnInit() {
  }
save(faculty:NgForm){
  let value = faculty.value;
  let descript = document.getElementById('display').innerHTML;
  let pictureurlsi = document.getElementById('pictureurl').innerHTML;
  console.log(pictureurlsi);
    let pictureurls = JSON.parse(pictureurlsi);
    let pictureurl = pictureurls.image;

  let desc = {desc:descript, pictureurl: pictureurl};
  let p ={...desc, ...faculty.value}
  console.log(p);
  let id = p.name;
  let db= firebase.database();
  db.ref('faculties/'+id).set({pictureurl: p.pictureurl,
  description: p.desc, name:id}, function(error){
    if(error){
      alert(error)
    }else{alert('data saved successfully')}
  })
}
}
